var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-in-touch"},[_c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Ainda possui dúvidas?")]),_c('p',[_vm._v("Tire suas dúvidas sobre nossos serviços e produtos")]),_c('router-link',{staticClass:"button",attrs:{"to":"/contato","tag":"button"}},[_vm._v("Fale conosco")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }